import React, { Component, Fragment } from 'react';
import TuneIcon from '@mui/icons-material/Tune';
import {
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  Input,
  Card,
  CardTitle,
  CardBody,
  ModalFooter,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardHeader,
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';
import noactivechats from '../../../../../assets/no_active_chats.png';
import noagentrole from '../../../../../assets/agent_role.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSms,
  faFilter,
  faPlus,
  faPhone,
  faReply,
  faTicketAlt,
  faArrowDown,
  faUpload,
  faLanguage,
} from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import Visitor from '../../ongoingconversations/components/visitor';
import Chat from '../../ongoingconversations/components/Chat';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select from 'react-select';
import { localeOptions } from '../../../../../constants/defaultValues';
import { Client as ConversationsClient } from '@twilio/conversations';
import {
  API_Web_RTC,
  postAPI_Create_Ticket,
  gAPI_Users_By_Id,
  gAPI_TicketsRecording_id,
  gAPI_QuickReplies,
  putAPI_ConversationsStatus_By_Id,
  postAPI_TrackEvent,
  putAPI_ConversationsTwilioStart,
  putAPI_ConversationsFacebookTransfer,
  gAPI_Conversations_By_Id,
  putAPI_UpdateAgentStatus_By_Id,
  gAPI_Conversations_Activelist,
  putAPI_UpdateChatStatus_By_Id,
  gAPI_QuickReplies_listByGroup,
} from '../../../../../constants/APIs';
import 'react-perfect-scrollbar/dist/css/styles.css';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
  AxiosPublicAPI,
} from '../../../../../helpers/AxiosAPI';

import {
  getChatList,
  getChatListSearch,
  getChat,
  getPropertyList,
  createTicket,
  BotBlink,
  AgentBlink,
  pushTwilioConversations,
} from '../../../../../redux/actions';

import { injectIntl } from 'react-intl';
import 'react-datepicker/dist/react-datepicker.css';
import {
  reactSelectOption,
  reactSelectOptionDiffrentPro,
} from '../../../../../helpers/Utils';
import Conversations from '../../ongoingconversations/components/Conversations';
import 'moment-timezone';
import { HubConnectionBuilder } from '@microsoft/signalr';
import * as signalR from '@microsoft/signalr';
import Validation from '../../../../../components/Validation';
import Masking from '../../../../../data/Masking';

import classnames from 'classnames';
import WebRTC from '../Connections/WebRTC';
import KnowledgeSearch from './knowledgeSearch';
import { UploadImagesForm } from '../../propinfo/gallery/components/UploadImagesForm';
import { AvailabilityAndRates } from './availability';
const TWILIO_URL = process.env.REACT_APP_CHAT_API + '/twilio';
const TWILIOCHANNEL_URL = process.env.REACT_APP_CHAT_API + '/twiliochannels';
const TWILIO_TOKEN_GEN_URL = process.env.REACT_APP_CHAT_API + '/twilio-token';
const STOPFB_URL = process.env.REACT_APP_CHAT_API + '/stopfb';
const RESUMEFB_URL = process.env.REACT_APP_CHAT_API + '/resumefb';
const TWILIO_END_CONVERSATION =
  process.env.REACT_APP_CHAT_API + '/endTwilioConversation';
const TWILIO_END_CHANNELCONVERSATION =
  process.env.REACT_APP_CHAT_API + '/endTwilioChannel';
const TicketTypeOptions = [
  { value: 'Booking & Rates Enquiry', label: 'Booking & Rates Enquiry' },
  { value: 'Change/Cancel Booking', label: 'Change/Cancel Booking' },
  { value: 'About Amenities', label: 'About Amenities' },
  { value: 'Special Request', label: 'Special Request' },
  { value: 'Other Query', label: 'Other Query' },
];

class ActiveConversation extends Component {
  constructor(props) {
    super(props);
    this._scrollBarRef1 = React.createRef();
    this.myChatRef = React.createRef();

    this.state = {
      startDate: moment().subtract(2, 'days'),
      // endDate: moment(),
      endDate: moment().add(1, 'days'),
      hotel: {},
      embeddedDate: moment(),
      items: 500,
      code: {},
      open: false,
      msg: [],
      topicName: {},
      isOnCall: false,
      offset: 0,
      loading: false,
      data: [],
      activeIndex: -1,
      ticketTitle: '',
      ticketComments: '',
      ticketType: null,
      ticketPriority: null,
      detailsTab: 'CallInfo',
      popupProperty: null,
      isVisibleTicketBtn: false,
      selectedChat: null,
      isLoading: false,
      isLoadmore: true,
      showLoadMoreBtn: false,
      isFiltering: true,
      showTwilioConversationList: false,
      twilioToken: '',
      transfertobot: false,
      transfertomesseger: false,
      facebookSenderName: '',
      recordingurl: '',
      transcript: '',
      channel: 'All',
      quickReplyTemplates: [],
      statusmodal: false,
      cstatus: 'Opened',
      filterstatus: 'Opened',
      googleSenderName: '',
      accessToken: '',
      twilioConversations: [],
      twilioChatId: '',
      newTwilioChatId: '',
      intervalId: null,
      forceRefresh: false,
      twilioLoaded: true,
      chatConnection: null,
      chatInvitations: [],
      agentConversations: [],
      waitingConversations: [],
      chatBotConversations: [],
      activeChat: '',
      agentAccess: undefined,
      chatReplyTemplates: [],
      isLatestConversation: false,
      isTranslate: false,
      translateLang: '',
      isMasked:
        sessionStorage.getItem('lock') === null
          ? 'false'
          : sessionStorage.getItem('lock'),
      // data: this.props.getChatList({pid:'0b999af2-e798-49ae-bac6-b00559fde7d0',items:10,offset:0})
    };
    this.audio = new Audio(
      'https://assets.bookmebob.com/images/chat_notification.mp3'
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.properties !== this.props.properties) {
      const permissionProperties = this.props.properties.map((z) => z.id);
      const data = {
        groupId: getGroupID(),
        properties: permissionProperties,
        agent: getUserID(),
      };
      //  console.log(data);
      AxiosAPI({
        method: 'post',
        url: `${gAPI_Conversations_Activelist}`,
        data: data,
      }).then(
        (res) => {
          //console.log(res.data);
          this.setState((state) => ({
            agentConversations: res.data?.myConversations || [],
            waitingConversations: res.data?.queueConversations || [],
            chatBotConversations: res.data?.botConversations || [],
            isLoading: false,
          }));
          if (
            res.data?.myConversations &&
            res.data.myConversations.length > 0
          ) {
            this.setState({
              activeChat: res.data.myConversations[0].conversationId,
              isVisibleTicketBtn: true,
            });
            this.props.getChat(res.data.myConversations[0].conversationId);
          } else if (
            res.data &&
            res.data.queueConversations &&
            res.data?.queueConversations &&
            res.data.queueConversations.length > 0
          ) {
            this.setState({
              activeChat: res.data.queueConversations[0].conversationId,
              isVisibleTicketBtn: true,
            });
            this.props.getChat(res.data.queueConversations[0].conversationId);
          } else if (
            res.data?.botConversations &&
            res.data.botConversations.length > 0
          ) {
          } else if (
            res.data &&
            res.data.botConversations &&
            res.data.botConversations.length > 0
          ) {
            this.setState({
              activeChat: res.data.botConversations[0].conversationId,
              isVisibleTicketBtn: true,
            });
            this.props.getChat(res.data.botConversations[0].conversationId);
          }
        },
        (error) => {
          this.setState({ loading: false, error, isLoading: false });
        }
      );
    }

    if (
      this.props.incomingchatId &&
      this.props.incomingchatId !== prevProps.incomingchatId
    ) {
      this.addConversationToQueue(this.props.incomingchatId);
    }

    if (
      this.props.incomingPopChatId &&
      this.props.incomingPopChatId !== prevProps.incomingPopChatId
    ) {
      this.SetSelectedChatPopup(this.props.incomingPopChatId);
    }
    // if (
    //   this.props.location !== undefined &&
    //   this.props.location.state !== undefined &&
    //   this.props.location.state.incomingchatId != undefined &&
    //   (prevProps.location.state === undefined ||
    //     this.props.location.state.incomingchatId !==
    //     prevProps.location.state.incomingchatId)
    // ) {
    //   console.log(
    //     'NEW  this.props.incomingchatId',
    //     this.props.location.state.incomingchatId
    //   );
    //   this.addConversationToQueue(this.props.location.state.incomingchatId)
    //   // this.acceptChat(this.props.location.state.incomingchatId);
    // }
  }

  componentDidMount() {
    //this.handleWebRTC();
    // try {
    //   var docElm = document.documentElement;
    //   if (docElm.requestFullscreen) {
    //     docElm.requestFullscreen();
    //   } else if (docElm.mozRequestFullScreen) {
    //     docElm.mozRequestFullScreen();
    //   } else if (docElm.webkitRequestFullScreen) {
    //     docElm.webkitRequestFullScreen();
    //   } else if (docElm.msRequestFullscreen) {
    //     docElm.msRequestFullscreen();
    //   }
    //   if (document.getElementById('app-container') !== undefined) {
    //     document.getElementById('app-container').classList.add("main-hidden");
    //     document.getElementById('app-container').classList.add("sub-hidden");
    //     console.log(document.getElementById('app-container'));
    //   }
    // } catch (err) {
    //   console.log('eroror', err);
    // }
    this.props.getPropertyList();
    moment.tz.setDefault(this.props.timeZone);
    this.setState({ isLoading: true });
    // let { offset, items } = this.state;
    // const start = this.minAgos();
    // const end = this.nowTime();

    // AxiosAPI({
    //   methhod: 'get',
    //   url: `${gAPI_Conversations_list}?gid=${getGroupID()}&pid=${
    //     this.props.propertyId
    //   }&df=${start}&dt=${end}&tags=-1&offset=${offset}&limit=${items}&country=-1&facebookSenderName=&channel=All
    //   }&status=Opened&googleSenderName=`,
    // }).then(
    //   (res) => {
    //     this.setState((state) => ({
    //       data: res.data.conversations,
    //       items: res.data.pageSize,
    //       offset: res.data.pageCount,
    //       isLoading: false,
    //     }));
    //     let { data } = this.state;
    //     if (data.length > 0) {
    //       this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
    //       this.props.getChat(data[0].conversationId);
    //     }
    //   },
    //   (error) => {
    //     this.setState({ loading: false, error, isLoading: false });
    //   }
    // );
    var identityBody = {
      identity: getUserID(),
    };
    fetch(TWILIO_TOKEN_GEN_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(identityBody),
    }).then((tokenResponse) => {
      tokenResponse.json().then((twilioToken) => {
        this.setState(
          { accessToken: twilioToken.accessToken },
          this.initConversations
        );
      });
    });

    // console.log('this.props.signalRConnection', this.props.signalRConnection);
    if (
      this.props.signalRConnection !== undefined &&
      this.props.signalRConnection.isAgent !== undefined
    ) {
      this.setState({ agentAccess: this.props.signalRConnection.isAgent });
    }

    if (this.props.signalRConnection.newConnection !== undefined) {
      this.props.signalRConnection.newConnection.connection.on(
        'newChatUserMessage',
        this.newChatMessage
      );
    }
    if (this.props.signalRConnection.newConnection !== undefined) {
      this.props.signalRConnection.newConnection.connection.on(
        'newChat',
        this.newChat
      );
      this.props.signalRConnection.newConnection.connection.on(
        'newAgentAcceptedChat',
        this.newChatAccepted
      );
    }
    // const protocol = new signalR.JsonHubProtocol();

    // // // Axios({
    // // //   method: 'post',
    // // //   url: 'http://localhost:7071/api/negotiate',
    // // //   headers: { 'x-ms-signalr-userid': this.props.propertyId },
    // // // }).then((resp) => {
    // this.setState(
    //   {
    //     connection: new signalR.HubConnectionBuilder()
    //       //Url of the azure function app
    //       .withUrl(`${process.env.REACT_APP_SIGNALR}/api`)
    //       .withHubProtocol(protocol)
    //       //.configureLogging(signalR.LogLevel.Trace)
    //       .build(),
    //   },
    //   () => {
    //     // opens the connection.

    //     this.state.connection
    //       .start()
    //       .then((con) => {
    //         console.log(this.state.connection);
    //         console.log('Connection established');

    //         // var a = { propertyId: this.props.propertyId };
    //         console.log(con);
    //         // this.state.connection.send('AddToGroup', {
    //         //   PopertyId: this.props.propertyId,
    //         //   UserId: getUserID(),
    //         // });
    //         // Axios({
    //         //   method: 'post',
    //         //   url: `http://localhost:7071/api/AddToGroup?userId=${getUserID()}&propertyId=${
    //         //     this.props.propertyId
    //         //   }`,
    //         // }).then((resp) => {});
    //         //this.state.connection.invoke('AddToGroup', this.props.propertyId);
    //       })
    //       .catch((err) => console.error(err, 'red'));

    //     // activates the drawing from the server.
    //     this.state.connection.on('newChatMessage', (message) => {
    //       console.log('newChatMessage', message);
    //     });
    //     this.state.connection.on('newChatUserMessage', (message) => {
    //       console.log('newChatUserMessage', message);
    //       console.log('this.state.selectedChat', this.state.selectedChat);
    //       if (
    //         this.state.selectedChat !== undefined &&
    //         message.ConversationId === this.state.selectedChat.conversationId
    //       ) {
    //         // console.log('type', message.Content.type);
    //         // console.log('content', message.Content.messages[0]);
    //         var m = {
    //           sender: message.Source == 'Visitor' ? true : false,
    //           source: message.Source,
    //           text: message.Content.messages[0],
    //           time: moment(message.TimeUtc),
    //           type: message.Content.type,
    //         };
    //         console.log(m);
    //         this.myChatRef.current.loadNewMessage(m);
    //       }
    //     });
    //     this.state.connection.on('newAgentChat', (message) => {
    //       console.log('newAgentChat', message);
    //       this.setState({
    //         chatInvitations: [message, ...this.state.chatInvitations],
    //       });
    //     });
    //     this.state.connection.on('newChat', (message) => {
    //       console.log('newChat', message);
    //       const checkConversations = this.state.data.filter(
    //         (m) => m.conversationId === message
    //       );
    //       if (checkConversations.length === 0) {
    //         AxiosAPI({
    //           methhod: 'get',
    //           url: `${gAPI_Conversations_By_Id}/${message}/conversation?gid=${getGroupID()}`,
    //         }).then(
    //           (res) => {
    //             //this.setState((state) => ({
    //             console.log(res.data);
    //             const newIndex = this.state.activeIndex + 1;
    //             //}));
    //             this.setState({
    //               data: [res.data, ...this.state.data],
    //               activeIndex: newIndex,
    //             });
    //             if (newIndex === 0) {
    //               this.props.getChat(res.data.conversationId);
    //             }
    //             this.audio.play();
    //           },
    //           (error) => {
    //             this.setState({ loading: false, error, isLoading: false });
    //           }
    //         );
    //       }
    //     });
    //     this.state.connection.on('newMessage', this.newMessage);
    //     this.state.connection.on('newConnection', this.newConnection);
    //     this.state.connection.on('disConnection', this.disConnection);
    //     // this.state.connection.onconnect((message) => {
    //     //   console.log('connected', message);
    //     //   Axios({
    //     //     method: 'get',
    //     //     url: `http://localhost:7071/api/AddToGroup?userId=${getUserID()}&propertyId=${
    //     //       this.props.propertyId
    //     //     }`,
    //     //   }).then((resp) => {
    //     //     console.log('Addgroup', resp.data);
    //     //   });
    //     // });
    //   }
    // );
    // // });

    // const connection = new HubConnectionBuilder()
    //   .withUrl('https://bmbcosmotest.azurewebsites.net/api')
    //   .withAutomaticReconnect()
    //   .build();

    // if (connection) {
    //   connection
    //     .start()
    //     .then((result) => {
    //       console.log('Connected Signal R!');
    //       console.log(connection);
    //       connection.on('updateSales', (message) => {
    //         console.log('message', message);
    //       });
    //     })
    //     .catch((e) => console.log('Connection failed: ', e));
    // }
    this.loadQuickTemmplates();
    console.log('componentDidMount active.js');
    if (this.props.incomingchatId) {
      console.log('incomingchatId found');
      this.addConversationToQueue(this.props.incomingchatId);
    }
  }

  handleMaskClick = () => {
    if (sessionStorage.getItem('lock') === 'true') {
      sessionStorage.setItem('lock', 'false');
      this.setState({ isMasked: 'false' });
    } else {
      sessionStorage.setItem('lock', 'true');
      this.setState({ isMasked: 'true' });
    }
  };
  // newMessage = (message) => {
  //   console.log('Message', message);
  // };
  // newConnection = (message) => {
  //   console.log('Message', message);
  //   //  data.myConnectionId = message.ConnectionId;
  //   // Axios({
  //   //   method: 'post',
  //   //   url: `http://localhost:7071/api/AddToGroup`,
  //   //   body: {
  //   //     connectionId: message.ConnectionId,
  //   //     recipient: getUserID(),
  //   //     groupname: this.props.propertyId,
  //   //   },
  //   // }).then((resp) => {});
  //   Axios({
  //     method: 'post',
  //     url: `${process.env.REACT_APP_SIGNALR}/api/AddToGroup`,
  //     data: {
  //       connectionId: message,
  //       recipient: getUserID(),
  //       groupname: this.props.propertyId,
  //     },
  //   }).then((resp) => {});
  // };

  // disConnection = (message) => {
  //   console.log('Message', message);
  //   //  data.myConnectionId = message.ConnectionId;
  //   // Axios({
  //   //   method: 'post',
  //   //   url: `http://localhost:7071/api/AddToGroup`,
  //   //   body: {
  //   //     connectionId: message.ConnectionId,
  //   //     recipient: getUserID(),
  //   //     groupname: this.props.propertyId,
  //   //   },
  //   // }).then((resp) => {});
  //   Axios({
  //     method: 'post',
  //     url: `${process.env.REACT_APP_SIGNALR}/api/RemoveFromGroup`,
  //     data: {
  //       connectionId: message,
  //       recipient: getUserID(),
  //       groupname: this.props.propertyId,
  //     },
  //   }).then((resp) => {});
  // };

  initConversations = async () => {
    window.conversationsClient = ConversationsClient;
    this.conversationsClient = await ConversationsClient.create(
      this.state.accessToken
    );
    this.conversationsClient.on('connectionStateChanged', (state) => {
      console.log(state);
    });

    this.conversationsClient.on('conversationJoined', (conversation) => {
      const newConversations = [
        ...this.state.twilioConversations,
        conversation,
      ];
      this.setState({ twilioConversations: newConversations });
      if (
        this.props.chatListApp.selectedchat !== undefined &&
        this.props.chatListApp.selectedchat !== null
      ) {
        if (
          this.props.chatListApp.selectedchat.twilioChatId === conversation.sid
        ) {
          this.setState({ forceRefresh: true });
        }
      }
    });
    this.conversationsClient.on('conversationLeft', (thisConversation) => {
      //console.log(thisConversation);
      // console.log('left');
      this.setState({
        twilioConversations: [
          ...this.state.twilioConversations.filter(
            (it) => it !== thisConversation
          ),
        ],
      });
    });
    if (this.props.location != null && this.props.location.state != null) {
      console.log(
        'this.props.incomingchatId',
        this.props.location.state.incomingchatId
      );
      if (this.props.location.state.incomingchatId) {
        this.addConversationToQueue(this.props.location.state.incomingchatId);
      }
      if (this.props.location.state.incomingPopChatId) {
        this.SetSelectedChatPopup(this.props.location.state.incomingPopChatId);
      }
      // this.acceptChat(this.props.location.state.incomingchatId);
    }
  };

  setTwilioChat = () => {
    let intervalId = setInterval(this.checkTwilioChatReady, 1000);
    this.setState({ intervalId: intervalId });
  };

  checkTwilioChatReady = () => {
    if (this.state.newTwilioChatId !== '') {
      const c = this.state.twilioConversations.filter(
        (m) => m.sid === this.state.newTwilioChatId
      );

      if (c.length > 0) {
        this.setState({ twilioChatId: c[0].sid, twilioLoaded: true });
        clearInterval(this.state.intervalId);

        if (
          this.props.twilioConversationsReducer !== undefined &&
          this.props.twilioConversationsReducer.twilioConversations !==
          undefined &&
          this.props.twilioConversationsReducer.twilioConversations.length > 0
        ) {
          const convo =
            this.props.twilioConversationsReducer.twilioConversations.filter(
              (m) => m.sid === this.state.newTwilioChatId
            );
          console.log(1419, convo);
          if (convo.length == 0) {
            this.props.pushTwilioConversations({ twilioChatId: c[0] });
          }
        } else {
          this.props.pushTwilioConversations({ twilioChatId: c[0] });
        }
      }
    }
  };

  setBlankTwilioId = () => {
    this.setState({ twilioChatId: '' });
  };

  newChatMessage = (message) => {
    console.log('newChatUserMessage', message);
    // console.log('this.state.selectedChat', this.state.selectedChat);
    const checkConversations = this.state.agentConversations.filter(
      (m) => m.conversationId === message.ConversationId
    );
    if (
      this.state.selectedChat !== undefined &&
      message.ConversationId === this.state.selectedChat.conversationId &&
      checkConversations.length == 0 &&
      message.AgentId !== getUserID()
    ) {
      // console.log('type', message.Content.type);
      // console.log('content', message.Content.messages[0]);
      var m = {
        sender: message.Source == 'Visitor' ? true : false,
        source: message.Source,
        text: message.Content.messages[0],
        time: moment(message.TimeUtc),
        type: message.Content.type,
      };
      // console.log(m);
      try {
        this.myChatRef.current.loadNewMessage(m);
      } catch (ex) { }
    }

    if (message.Source == 'Visitor') {
      var agentindex = this.state.agentConversations.findIndex(
        (a) => a.conversationId === message.ConversationId
      );
      // console.log('AgentIdex', agentindex);
      if (agentindex > -1) {
        const values = [...this.state.agentConversations];
        values[agentindex].visitorMessageCount =
          values[agentindex].visitorMessageCount + 1;
        this.setState({
          agentConversations: values,
        });
      } else {
        var queueindex = this.state.waitingConversations.findIndex(
          (a) => a.conversationId === message.ConversationId
        );
        // console.log('queueindex', queueindex);
        if (queueindex > -1) {
          const values = [...this.state.waitingConversations];
          values[queueindex].visitorMessageCount =
            values[queueindex].visitorMessageCount + 1;
          this.setState({
            waitingConversations: values,
          });
        } else {
          var chatindex = this.state.chatBotConversations.findIndex(
            (a) => a.conversationId === message.ConversationId
          );
          // console.log('chatindex', chatindex);
          if (chatindex > -1) {
            const values = [...this.state.chatBotConversations];
            values[chatindex].visitorMessageCount =
              values[chatindex].visitorMessageCount + 1;
            this.setState({
              chatBotConversations: values,
            });
          }
        }
      }
    }

    if (
      message.AgentId === getUserID() &&
      message.Source == 'Visitor' &&
      this.state.selectedChat !== undefined &&
      message.ConversationId !== this.state.selectedChat.conversationId
    ) {
      var agentindex = this.state.agentConversations.findIndex(
        (a) => a.conversationId === message.ConversationId
      );
      // console.log('AgentIdex', agentindex);
      if (agentindex > -1) {
        const values = [...this.state.agentConversations];
        values[agentindex].newMessage = true;
        this.setState({
          agentConversations: values,
        });
      }
    }
  };

  newChatAccepted = (message) => {
    console.log('newChatAccepted', message);
    const queueConversations = this.state.waitingConversations.filter(
      (m) => m.conversationId === message.ConversationId
    );
    console.log('queueConversations-715', queueConversations);
    if (queueConversations.length > 0) {
      const agents = message.Agents.filter((a) => a === getUserID());
      if (agents.length === 0) {
        this.setState({
          chatBotConversations: [
            queueConversations[0],
            ...this.state.chatBotConversations,
          ],
        });
      }
    }

    var agentindex = this.state.waitingConversations.findIndex(
      (a) => a.conversationId === message.ConversationId
    );
    if (agentindex > -1) {
      const values = [...this.state.waitingConversations];
      values.splice(agentindex, 1);
      this.setState({ waitingConversations: values });
    }
  };

  newChat = (message) => {
    //console.log('newChat', message);
    const checkConversations = this.state.chatBotConversations.filter(
      (m) => m.conversationId === message
    );
    const agentConversations = this.state.agentConversations.filter(
      (m) => m.conversationId === message
    );
    const queueConversations = this.state.waitingConversations.filter(
      (m) => m.conversationId === message
    );
    if (
      checkConversations.length === 0 &&
      agentConversations.length === 0 &&
      queueConversations.length === 0
    ) {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Conversations_By_Id}/${message}/conversation?gid=${getGroupID()}`,
      }).then(
        (res) => {
          //this.setState((state) => ({
          //console.log(res.data);
          //const newIndex = this.state.activeIndex + 1;
          //}));
          this.setState({
            chatBotConversations: [
              res.data,
              ...this.state.chatBotConversations,
            ],
            // activeIndex: newIndex,
          });
          // if (newIndex === 0) {
          //   this.props.getChat(res.data.conversationId);
          // }
          this.audio.play();
        },
        (error) => {
          this.setState({ loading: false, error, isLoading: false });
        }
      );
    }
  };

  componentWillReceiveProps(props) {
    if (
      props.chatListApp.selectedchat !== this.props.chatListApp.selectedchat
    ) {
      this.setState({
        selectedChat: props.chatListApp.selectedchat,
        cstatus: props.chatListApp.selectedchat.status,
        twilioChatId: props.chatListApp.selectedchat.twilioChatId,
      });
      if (props.chatListApp.selectedchat !== undefined) {
        let chat = props.chatListApp.selectedchat;
        let messages = chat.messages.filter((f) => f.source === 'Visitor');
        let lst = messages[messages.length - 1];
        if (
          chat.channel === 'WhatsApp' &&
          lst !== undefined &&
          moment().diff(moment(lst.time), 'hours') <= 24
        )
          this.setState({ isLatestConversation: true });
        else this.setState({ isLatestConversation: false });
      }
      if (
        props.chatListApp.selectedchat.visitor &&
        props.chatListApp.selectedchat.visitor.contactId
      ) {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_TicketsRecording_id}?contactid=${props.chatListApp.selectedchat.visitor.contactId}`,
        }).then(
          (urlres) => {
            this.setState({
              recordingurl: urlres.data.url,
              //selectedChat: res.data,
              transcript: urlres.data.transcript,
            });
          },
          (error) => {
            console.log(error);
          }
        );
      } else {
        this.setState({
          recordingurl: '',
          // selectedChat: res.data,
          transcript: '',
        });
      }
    }
    // console.log('props.signalRConnectio', props.signalRConnection);
    if (
      props.signalRConnection !== undefined &&
      props.signalRConnection.newConnection !== undefined &&
      this.props.signalRConnection.newConnection === undefined
    ) {
      props.signalRConnection.newConnection.connection.on(
        'newChatUserMessage',
        this.newChatMessage
      );
      props.signalRConnection.newConnection.connection.on(
        'newChat',
        this.newChat
      );
      props.signalRConnection.newConnection.connection.on(
        'newAgentAcceptedChat',
        this.newChatAccepted
      );
    }

    if (
      props.signalRConnection !== undefined &&
      props.signalRConnection.isAgent !== undefined
    ) {
      this.setState({ agentAccess: props.signalRConnection.isAgent });
    }
  }

  handleChangeSelect = (value, { name }) => {
    this.setState({
      [name]: value,
    });
  };
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  loadQuickTemmplates = () => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_QuickReplies}?groupId=${getGroupID()}&propertyId=${this.props.propertyId
        }&locale=${this.props.locale}`,
    }).then(
      (res) => {
        this.setState((state) => ({
          quickReplyTemplates: res.data,
        }));
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );

    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_QuickReplies_listByGroup}?groupId=${getGroupID()}&propertyId=&locale=${this.props.locale
        }`,
    }).then(
      (res) => {
        this.setState((state) => ({
          chatReplyTemplates: res.data,
        }));
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
  };

  minAgos = () => {
    return moment(moment().subtract(3600, 'seconds'))
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  nowTime = () => {
    return moment().utc().format('YYYY-MM-DD HH:mm:ss');
  };

  handleContactClick = (index, conversationId) => {
    this.setState({ activeChat: conversationId, isVisibleTicketBtn: true });
    this.stopBlink();
    const chat = this.props.getChat(conversationId);
    var agentindex = this.state.agentConversations.findIndex(
      (a) => a.conversationId === conversationId
    );
    //console.log('AgentIdex', agentindex);
    if (agentindex > -1) {
      const values = [...this.state.agentConversations];
      values[agentindex].newMessage = false;
      this.setState({
        agentConversations: values,
      });
    }
  };

  statustoggle = () => {
    this.setState((prevState) => ({
      statusmodal: !prevState.statusmodal,
    }));
  };

  toggle = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };

  toggleMessanger = () => {
    this.setState((prevState) => ({
      transfertomesseger: !prevState.transfertomesseger,
    }));
  };

  togglebot = () => {
    this.setState((prevState) => ({
      transfertobot: !prevState.transfertobot,
    }));
  };

  toggleTwillioConversation = () => {
    this.setState({
      showTwilioConversationList: !this.state.showTwilioConversationList,
    });
  };

  closeTwilioConversation = (sid, conversationId, channel) => {
    // if (event.target.tagName == 'svg') {
    fetch(
      `${channel === 'WebsiteDirectLine'
        ? TWILIO_END_CONVERSATION
        : TWILIO_END_CHANNELCONVERSATION
      }`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          twilioConversationId: sid,
          channel: channel,
          message: `Agent ${this.props.user && this.props.user.profile.name
            } has left the conversation`,
        }),
      }
    ).then((res) => {
      console.log('Closed');
    });
    AxiosAPI({
      method: 'put',
      url: `${putAPI_UpdateChatStatus_By_Id}/${conversationId}`,
      data: {
        groupId: getGroupID(),
        userId: getUserID(),
        status: 'Ended',
      },
    });

    AxiosAPI({
      method: 'put',
      url: `${putAPI_ConversationsTwilioStart}/${conversationId}`,
      data: {
        groupId: getGroupID(),
        twilioChatId: '',
      },
    }).then((d) => { });
    this.setState({ twilioChatId: '' });

    // var array = [...this.state.agentConversations]; // make a separate copy of the array
    // var index = array.findIndex((a) => a.conversationId === conversationId);
    // // console.log(index);
    // if (index !== -1) {
    //   array.splice(index, 1);
    //   this.setState({ agentConversations: array });
    // }
    // }
  };

  StopFacebookChat = (botConversationId) => {
    // console.log(botConversationId);
    AxiosPublicAPI({
      method: 'get',
      url: `${STOPFB_URL}/${botConversationId}`,
    }).then((userData) => {
      // console.log('stop FB');
      this.toggleMessanger();
      AxiosAPI({
        method: 'put',
        url: `${putAPI_ConversationsFacebookTransfer}/${this.state.selectedChat.conversationId}`,
        data: {
          groupId: getGroupID(),
          transfer: true,
        },
      }).then((d) => { });
    });
  };

  ResumeFacebookChat = (botConversationId) => {
    AxiosPublicAPI({
      method: 'get',
      url: `${RESUMEFB_URL}/${botConversationId}`,
    }).then((userData) => {
      //console.log('resume FB');
      this.togglebot();
      AxiosAPI({
        method: 'put',
        url: `${putAPI_ConversationsFacebookTransfer}/${this.state.selectedChat.conversationId}`,
        data: {
          groupId: getGroupID(),
          transfer: false,
        },
      }).then((d) => { });
    });
  };

  handleTicketSubmit = () => {
    const { ticketComments, ticketType, popupProperty, selectedChat } =
      this.state;
    let tickets = [];
    ticketType && ticketType.map((ticket) => tickets.push(ticket.value));

    const data = {
      notes: ticketComments,
      tags: tickets,
      creator: 'Dashboard',
      Source: 'BobDashboard',
      conversationId: selectedChat.botConversationId,
      propertyId: popupProperty && popupProperty.value,
      groupId: selectedChat.groupId,
    };

    AxiosAPI({
      method: 'post',
      url: `${postAPI_Create_Ticket}`,
      data,
    })
      .then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          this.setState({ msg: res.data.Messages });
          this.setState({ open: true });
        } else this.toggle();
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  handleStatusSubmit = () => {
    const id = this.state.selectedChat.conversationId;
    AxiosAPI({
      method: 'put',
      url: `${putAPI_ConversationsStatus_By_Id}/${this.state.selectedChat.conversationId}`,
      data: {
        groupId: this.state.selectedChat.groupId,
        status: this.state.cstatus,
      },
    }).then(
      (res) => {
        if (this.state.filterstatus !== 'All') {
          const newList = this.state.data.filter(
            (item) => item.conversationId !== id
          );
          this.setState({ data: newList });
        } else {
          this.props.getChat(id);
        }
        this.statustoggle();
      },
      (error) => { }
    );
  };

  acceptChat = (id) => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Conversations_By_Id}/${id}?gid=${getGroupID()}`,
    }).then(
      (res) => {
        //console.log(res.data);
        if (res.data.handedOffToAgent === false) {
          this.twilioConnectionToUserChat(
            res.data.botConversationId,
            res.data.visitor.location,
            res.data.visitor.ipAddress,
            id,
            res.data.channel
          );
        }
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
  };

  handleWebRTC = () => {
    if (
      this.props.integrations !== undefined &&
      this.props.integrations.filter(
        (f) =>
          f.channel === 'WebRTC' &&
          f.properties.includes(this.props.propertyId) &&
          f.disabled === false
      ).length > 0
    ) {
      AxiosAPI({
        method: 'get',
        url: `${API_Web_RTC}/${this.props.integrations.filter(
          (f) =>
            f.channel === 'WebRTC' &&
            f.properties.includes(this.props.propertyId) &&
            f.disabled === false
        )[0].id
          }?group_id=${getGroupID()}`,
      }).then((res) => {
        if (res.data.webRTCIntegration !== undefined) {
          console.log(res.data);
          this.setState({ webRTCIntegration: res.data.webRTCIntegration });
        }
      });
    }
  };

  getVisitorNameDetail = () => {
    if (this.state.selectedChat !== undefined) {
      let channel = this.state.selectedChat?.channel;
      let visitor = this.state.selectedChat?.visitor;
      let name = '';
      if (visitor !== undefined) {
        if (channel !== undefined && channel === 'PhoneSuite') {
          return (
            <span className="ml-1 mt-1" style={{ width: '30%' }}>
              {visitor.nmsAni}
            </span>
          );
        } else {
          let startTime = moment().format('YYYY-MM-DD h:mm a');
          let endTime = moment(this.state.selectedChat.startedUtc).format(
            'YYYY-MM-DD h:mm a'
          );
          let hoursDiff = moment(startTime).diff(endTime, 'hours');
          if (
            visitor?.name &&
            visitor.name !== null &&
            visitor.name !== '' &&
            hoursDiff > 24
          )
            return (
              <span className="ml-1" style={{ width: '32%' }}>
                {visitor.name}
              </span>
            );
          else if (
            visitor?.email &&
            visitor.email !== null &&
            visitor.email !== '' &&
            hoursDiff > 24
          )
            return (
              <span className="ml-1" style={{ width: '32%' }}>
                {visitor.email}
              </span>
            );
          else if (
            visitor?.phoneNumber &&
            visitor.phoneNumber !== null &&
            visitor.phoneNumber !== '' &&
            hoursDiff > 24
          )
            return (
              <span className="ml-1" style={{ width: '32%' }}>
                {visitor.phoneNumber}
              </span>
            );
          else if (
            visitor?.location &&
            visitor.location !== null &&
            visitor.location !== '' &&
            hoursDiff > 24
          )
            return (
              <span className="ml-1" style={{ width: '32%' }}>
                {visitor.location}
              </span>
            );
        }
      }
    }
    return <span className="ml-1" style={{ width: '32%' }}></span>;
  };

  getVisitorOnlineDetail = () => {
    if (this.state.selectedChat !== undefined) {
      let channel = this.state.selectedChat?.channel;
      let visitor = this.state.selectedChat?.visitor;
      let hoursDiff = 0;
      if (visitor !== undefined) {
        let startTime = moment().format('YYYY-MM-DD h:mm a');
        let endTime = moment(this.state.selectedChat.startedUtc).format(
          'YYYY-MM-DD h:mm a'
        );
        hoursDiff = moment(startTime).diff(endTime, 'hours');
        let minDiff = moment(startTime).diff(endTime, 'minutes');
        if (channel !== undefined && channel === 'PhoneSuite') {
          if (hoursDiff === 0) {
            if (minDiff <= 0) {
              return (
                <p
                  className="ml-1 mt-2"
                  style={{ position: 'absolute', top: '15px' }}
                >
                  Active an minute ago
                </p>
              );
            } else {
              return (
                <p
                  className="ml-1 mt-2"
                  style={{ position: 'absolute', top: '15px' }}
                >
                  Active {minDiff} minutes ago
                </p>
              );
            }
          }
          if (hoursDiff <= 1) {
            return (
              <p
                className="ml-1 mt-2"
                style={{ position: 'absolute', top: '15px' }}
              >
                Called an hour ago
              </p>
            );
          } else if (hoursDiff <= 24) {
            return (
              <p
                className="ml-1 mt-2"
                style={{ position: 'absolute', top: '15px' }}
              >
                Called {hoursDiff} hours ago
              </p>
            );
          } else {
            return '';
          }
        } else {
          if (hoursDiff === 0) {
            if (minDiff <= 0) {
              return (
                <p
                  className="ml-1 mt-2"
                  style={{ position: 'absolute', top: '8px' }}
                >
                  Active an minute ago
                </p>
              );
            } else {
              return (
                <p
                  className="ml-1 mt-2"
                  style={{ position: 'absolute', top: '8px' }}
                >
                  Active {minDiff} minutes ago
                </p>
              );
            }
          }
          if (hoursDiff <= 1) {
            return (
              <p
                className="ml-1 mt-1"
                style={{ position: 'absolute', top: '8px' }}
              >
                Online an hour ago
              </p>
            );
          } else if (hoursDiff <= 24) {
            return (
              <p
                className="ml-1 mt-1"
                style={{ position: 'absolute', top: '8px' }}
              >
                Online {hoursDiff} hours ago
              </p>
            );
          } else {
            return '';
          }
        }
      }
    }
  };

  // twilioMakingConnection = (
  //   botConversationId,
  //   location,
  //   ipAddress,
  //   botCoversationMessages
  // ) => {
  //   this.setState({ twilioLoaded: false });
  //   AxiosAPI({
  //     method: 'get',
  //     url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
  //   }).then((userData) => {
  //     let requestBody = {
  //       conversationId: botConversationId,
  //       bmbUser: getUserID(),
  //       location: location,
  //       ipAddress: ipAddress,
  //       welcomeMessage: `Agent ${userData.data.fullName} has joined`,
  //     };
  //     //console.log("botConversationId", botConversationId)

  //     AxiosPublicAPI({
  //       method: 'post',
  //       url: `${
  //         channel === 'WebsiteDirectLine' ? TWILIO_URL : TWILIOCHANNEL_URL
  //       }`,
  //       data: requestBody,
  //     }).then(
  //       (res) => {
  //         if (res.data.twilioConversationId !== undefined) {
  //           AxiosAPI({
  //             method: 'put',
  //             url: `${putAPI_ConversationsTwilioStart}/${this.state.selectedChat.conversationId}`,
  //             data: {
  //               groupId: getGroupID(),
  //               twilioChatId: res.data.twilioConversationId,
  //             },
  //           }).then((d) => {});
  //           this.setState({ newTwilioChatId: res.data.twilioConversationId });
  //           this.setTwilioChat();
  //           //this.twilioStartChat();
  //         }
  //       },
  //       (error) => {
  //         this.setState({ twilioLoaded: true });
  //         console.log(error);
  //       }
  //     );
  //   });
  // };

  SetSelectedChatPopup = (conversationId) => {
    const checkConversations = this.state.agentConversations.filter(
      (m) => m.conversationId === conversationId
    );
    if (checkConversations.length > 0) {
      console.log('1394', 'SetSelectedChatPopup');
      this.setState({
        activeChat: checkConversations[0].conversationId,
      });
      this.props.getChat(checkConversations[0].conversationId);
    }
  };

  addConversationToQueue = (conversationId) => {
    const checkConversations = this.state.waitingConversations.filter(
      (m) => m.conversationId === conversationId
    );
    if (checkConversations.length === 0) {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Conversations_By_Id}/${conversationId}/conversation?gid=${getGroupID()}`,
      }).then(
        (res) => {
          console.log('1379', 'addint to queue');
          this.setState({
            waitingConversations: [
              res.data,
              ...this.state.waitingConversations,
            ],
            activeChat: res.data.conversationId,
          });
          //if (newIndex === 0) {
          this.props.getChat(res.data.conversationId);
          //}
          this.audio.play();
        },
        (error) => {
          this.setState({ loading: false, error, isLoading: false });
        }
      );
    } else {
      console.log('1394', 'addint to queue');
      this.setState({
        // waitingConversations: [
        //   checkConversations[0],
        //   ...this.state.waitingConversations,
        // ],
        activeChat: checkConversations[0].conversationId,
      });
      this.props.getChat(checkConversations[0].conversationId);
    }

    var array = [...this.state.chatBotConversations]; // make a separate copy of the array
    // console.log(
    //   'this.state.chatBotConversations', array);
    var index = array.findIndex((a) => a.conversationId === conversationId);
    //console.log(index);
    if (index !== -1) {
      array.splice(index, 1);
      //console.log('array', array);
      this.setState({ chatBotConversations: array });
    }
  };

  twilioConnectionToUserChat = (
    botConversationId,
    location,
    ipAddress,
    conversationId,
    channel
  ) => {
    console.log(
      botConversationId,
      location,
      ipAddress,
      conversationId,
      channel,
      1321
    );
    this.setState({ twilioLoaded: false });
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((userData) => {
      let requestBody = {
        conversationId: botConversationId,
        bmbUser: getUserID(),
        location: location,
        ipAddress: ipAddress,
        welcomeMessage: `Agent ${userData.data.fullName} has joined`,
        channel: channel,
      };
      //console.log("botConversationId", botConversationId)
      AxiosPublicAPI({
        method: 'post',
        url: `${channel === 'WebsiteDirectLine' ? TWILIO_URL : TWILIOCHANNEL_URL
          }`,
        data: requestBody,
      }).then(
        (res) => {
          if (res.data.twilioConversationId !== undefined) {
            AxiosAPI({
              method: 'put',
              url: `${putAPI_ConversationsTwilioStart}/${conversationId}`,
              data: {
                groupId: getGroupID(),
                twilioChatId: res.data.twilioConversationId,
              },
            }).then((d) => { });
            this.setState({ newTwilioChatId: res.data.twilioConversationId });
            this.setTwilioChat();
            if (res.data.twilioConversationId !== undefined) {
              const agentIndex = this.state.agentConversations.findIndex(
                (a) => a.conversationId === conversationId
              );

              if (agentIndex > -1) {
                const updatedAgentConversations = [
                  ...this.state.agentConversations,
                ];
                updatedAgentConversations[agentIndex] = {
                  ...updatedAgentConversations[agentIndex],
                  twilioChatId: res.data.twilioConversationId,
                };

                // Keep newTwilioChatId and update the specific agent conversation
                this.setState({
                  agentConversations: updatedAgentConversations,
                });
              }
            }
            //this.twilioStartChat();
          }
        },
        (error) => {
          this.setState({ twilioLoaded: true });
          console.log(error);
        }
      );
    });

    AxiosAPI({
      method: 'put',
      url: `${putAPI_UpdateAgentStatus_By_Id}/${conversationId}`,
      data: {
        groupId: getGroupID(),
        userId: getUserID(),
        status: 'Accepted',
      },
    }).then(() => {
      //console.log('Accepted');
      const checkConversations = this.state.chatBotConversations.filter(
        (m) => m.conversationId === conversationId
      );
      if (checkConversations.length === 0) {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Conversations_By_Id}/${conversationId}/conversation?gid=${getGroupID()}`,
        }).then(
          (res) => {
            //this.setState((state) => ({
            //console.log(res.data);
            //const newIndex = this.state.activeIndex + 1;
            //}));
            this.setState({
              agentConversations: [res.data, ...this.state.agentConversations],
              activeChat: res.data.conversationId,
            });
            //if (newIndex === 0) {
            this.props.getChat(res.data.conversationId);
            //}
            this.audio.play();
          },
          (error) => {
            this.setState({ loading: false, error, isLoading: false });
          }
        );
      } else {
        this.setState({
          agentConversations: [
            checkConversations[0],
            ...this.state.agentConversations,
          ],
          activeChat: checkConversations[0].conversationId,
        });
        this.props.getChat(checkConversations[0].conversationId);
        var array = [...this.state.chatBotConversations]; // make a separate copy of the array
        // console.log(
        //   'this.state.chatBotConversations',
        //   this.state.chatBotConversations
        // );

        var index = array.findIndex((a) => a.conversationId === conversationId);
        //console.log(index);
        if (index !== -1) {
          array.splice(index, 1);
          //console.log('array', array);
          this.setState({ chatBotConversations: array });
        }
      }

      const queueConversations = this.state.waitingConversations.filter(
        (m) => m.conversationId === conversationId
      );
      console.log('queueConversations-1537', queueConversations);
      if (queueConversations.length > 0) {
        var array = [...this.state.waitingConversations];
        var index = array.findIndex((a) => a.conversationId === conversationId);
        //console.log(index);
        if (index !== -1) {
          array.splice(index, 1);
          //console.log('array', array);
          this.setState({ waitingConversations: array });
        }
      }
    });
  };

  stopBlink = () => {
    this.props.BotBlink(false);
    this.props.AgentBlink(false);
  };
  handleChangeLocale = async (locale, direction) => {
    this.setState({ translateLang: locale, isTranslate: true });
  };
  TransferBotToMessanger = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="12" className="mb-1">
              <Modal
                isOpen={this.state.transfertomesseger}
                keyboard="false"
                backdrop="static"
                toggle={this.toggleMessanger}
              >
                <ModalHeader>Handover to Messenger</ModalHeader>
                <ModalBody>
                  <p>
                    {' '}
                    Chatbot will stop responding to the user messages, and you
                    will need to respond from the Facebook Messenger app. You
                    can anytime give control back to the chatbot for this
                    Facebook user.{' '}
                  </p>
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={this.toggleMessanger}>
                    Continue
                  </Button>
                </ModalFooter>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  TransferToBot = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="12" className="mb-1">
              <Modal
                isOpen={this.state.transfertobot}
                keyboard="false"
                backdrop="static"
                toggle={this.togglebot}
              >
                <ModalHeader>Handover to Chatbot</ModalHeader>
                <ModalBody>
                  <p>
                    {' '}
                    Chatbot will start responding to this user messages. You can
                    anytime take control back from the chatbot for this Facebook
                    user.
                  </p>
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={this.togglebot}>
                    Continue
                  </Button>
                </ModalFooter>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  getVisitorCallingNumber = () => {
    var chat = this.state.selectedChat;
    if (chat !== undefined) {
      var visitor = chat?.visitor;
      if (visitor !== undefined) {
        if (visitor?.nmsAni && visitor.nmsAni !== '')
          return visitor?.nmsAni ? visitor.nmsAni : '';
        else if (visitor?.phoneNumber && visitor.phoneNumber !== '')
          return visitor?.phoneNumber ? visitor.phoneNumber : '';
        else if (
          visitor?.whatsAppSenderPhoneNumber &&
          visitor.whatsAppSenderPhoneNumber !== ''
        )
          return visitor?.whatsAppSenderPhoneNumber
            ? visitor.whatsAppSenderPhoneNumber
            : '';
        else return '';
      }
      return '';
    }
    return '';
  };

  render() {
    const {
      usersListApp: { properties },
      signalRConnection,
      user,
      featuresUrl,
    } = this.props;
    const {
      selectedChat,
      startDate,
      endDate,
      modal,
      ticketType,
      ticketPriority,
      popupProperty,
      isVisibleTicketBtn,
      webRTCIntegration,
      rtcNumber,
      detailsTab,
    } = this.state;
    const imageDomain =
      featuresUrl && !featuresUrl.includes('myma.ai')
        ? `https://assets.${featuresUrl}`
        : 'https://assets.bookmebob.com';

    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Modal isOpen={modal} toggle={this.toggle} size="lg">
              <ModalHeader toggle={this.toggle}>
                <IntlMessages id="Ticket Details" />
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Colxx xxs="12">
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label>
                          <IntlMessages id="Ticket Type" />
                        </label>
                      </Colxx>
                      <Colxx xxs="9">
                        <Select
                          isMulti={true}
                          className="react-select"
                          classNamePrefix="react-select"
                          name="ticketType"
                          value={ticketType}
                          onChange={this.handleChangeSelect}
                          options={TicketTypeOptions}
                        />
                      </Colxx>
                    </Row>
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label>
                          <IntlMessages id="Property" />
                        </label>
                      </Colxx>
                      <Colxx xxs="9">
                        <Select
                          className="react-select"
                          classNamePrefix="react-select"
                          name="popupProperty"
                          value={properties && popupProperty}
                          onChange={this.handleChangeSelect}
                          options={
                            properties
                              ? reactSelectOption(properties, false)
                              : []
                          }
                        />
                      </Colxx>
                    </Row>
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label>
                          <IntlMessages id="Comments" />
                        </label>
                      </Colxx>
                      <Colxx xxs="9">
                        <Input className='input_sty'
                          name="ticketComments"
                          onChange={this.handleInputChange}
                          type="textarea"
                          placeholdertext="Comments"
                        />
                      </Colxx>
                    </Row>
                    <Row>
                      <Colxx xxs="3">
                        <Button
                          color="primary"
                          className="mb-2"
                          onClick={this.handleTicketSubmit}
                        >
                          <IntlMessages id="forms.submit" />
                        </Button>
                      </Colxx>
                    </Row>
                  </Colxx>
                </Row>
              </ModalBody>
            </Modal>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-4 pr-0">
            <CardHeader className="pl-1 pr-1 pt-4">
              <Nav
                tabs
                className="card-header-tabs ml-2 mb-2"
                style={{
                  backgroundColor: 'white',
                  border: '1px solid lightgray',
                }}
              >
                <NavItem className="text-center nav-width">
                  <NavLink
                    style={{
                      background: `${this.props.activeTab === 'Active' ? 'white' : 'none'
                        }`,
                      cursor: 'pointer',
                      paddingTop: '12px',
                      paddingBottom: '12px',
                    }}
                    className={classnames({
                      active: this.props.activeTab === 'Active',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      this.props.handleSelectedTab('Active');
                    }}
                    to="#"
                    title="Active Conversations"
                  >
                    <i className="svg-class">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLineJoin="round"
                          d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                        />
                      </svg>
                    </i>

                    {this.props.activeTab === 'Active' && (
                      <IntlMessages id="content.active" />
                    )}
                  </NavLink>
                </NavItem>
                <NavItem className="text-center nav-width">
                  <NavLink
                    style={{
                      background: `${this.props.activeTab === 'AllConversations'
                        ? 'white'
                        : 'none'
                        }`,
                      cursor: 'pointer',
                      paddingTop: '12px',
                      paddingBottom: '12px',
                    }}
                    className={classnames({
                      active: this.props.activeTab === 'AllConversations',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      this.props.handleSelectedTab('AllConversations');
                    }}
                    to="#"
                    title="All Conversations"
                  >
                    <i className="svg-class">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLineJoin="round"
                          d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 0 1 1.037-.443 48.282 48.282 0 0 0 5.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                        />
                      </svg>
                    </i>
                  </NavLink>
                </NavItem>
                <NavItem className="text-center nav-width">
                  <NavLink
                    style={{
                      background: `${this.props.activeTab === 'Tickets' ? 'white' : 'none'
                        }`,
                      cursor: 'pointer',
                      paddingTop: '12px',
                      paddingBottom: '12px',
                    }}
                    className={classnames({
                      active: this.props.activeTab === 'Tickets',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      this.props.handleSelectedTab('Tickets');
                    }}
                    to="#"
                    title="Tickets"
                  >
                    <i className="svg-class">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLineJoin="round"
                          d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z"
                        />
                      </svg>
                    </i>
                  </NavLink>
                </NavItem>
              </Nav>
            </CardHeader>
            <TabContent activeTab={this.props.activeTab} className="">
              <TabPane tabId="Active" className="chat-app-tab-pane">
                {this.state?.twilioLoaded &&
                  (this.state?.chatBotConversations?.length > 0 ||
                    this.state?.agentConversations?.length > 0 ||
                    this.state?.waitingConversations?.length > 0) &&
                  this.state?.agentAccess === true && (
                    <Conversations
                      isAgentAssist={true}
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      offset={this.state.offset}
                      items={this.state.items}
                      isLoading={this.state.isLoading}
                      data={this.state.data}
                      activeIndex={this.state.activeIndex}
                      pid={this.props.propertyId}
                      handleContactClick={this.handleContactClick}
                      agentConversations={this.state.agentConversations}
                      waitingConversations={this.state.waitingConversations}
                      chatBotConversations={this.state.chatBotConversations}
                      activeChat={this.state.activeChat}
                      handleMaskClick={this.handleMaskClick}
                      isMasked={this.state.isMasked}
                      properties={this.props.properties}
                      imageDomain={imageDomain}
                    />
                  )}

                {this.state.chatBotConversations.length === 0 &&
                  this.state.waitingConversations.length === 0 &&
                  this.state.agentConversations.length === 0 &&
                  this.state.isLoading === false &&
                  this.state.agentAccess === true && (
                    <Fragment>
                      <Card className="cardHeightTickets ml-2 card-box">
                        <img
                          src={noactivechats}
                          alt="No Active Conversations"
                          style={{
                            width: '60%',
                            marginLeft: '6rem',
                            marginTop: '8rem',
                          }}
                        />
                      </Card>
                    </Fragment>
                  )}
              </TabPane>
            </TabContent>
          </Colxx>
          <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-4 pr-0">
            {this.state?.twilioLoaded &&
              (this.state?.chatBotConversations?.length > 0 ||
                this.state?.agentConversations?.length > 0 ||
                this.state?.waitingConversations?.length > 0) &&
              this.state?.agentAccess === true && (
                <Fragment>
                  {selectedChat !== undefined && (
                    <CardHeader className="pl-0 pr-0 pt-4">
                      <Nav
                        tabs
                        className="card-header-tabs ml-0 mr-0"
                        style={{
                          backgroundColor: 'white',
                          border: '1px solid lightgray',
                          height: '50.5px',
                        }}
                      >
                        <NavItem
                          className="text-center"
                          style={{ width: '100%', background: '' }}
                        >
                          <Row className="px-0">
                            <Colxx md={12} className="text-left">
                              <div className="d-flex ml-4">
                                {this.getVisitorNameDetail()}
                                <div
                                  className="text-right my-2 d-flex"
                                  style={{ width: '75%' }}
                                >
                                  <Button
                                    size="xs"
                                    outline
                                    color="primary"
                                    onClick={this.toggle}
                                    className="ml-2 btn-round"
                                    style={{
                                      marginTop: '4px',
                                      marginBottom: '4px',
                                    }}
                                    title="Convert to Ticket"
                                  >
                                    <FontAwesomeIcon
                                      icon={faTicketAlt}
                                    ></FontAwesomeIcon>{' '}
                                    {/* <IntlMessages id="dashboards.tickets" /> */}
                                  </Button>
                                  {this.state.twilioChatId !== '' ? null : (
                                    <Button
                                      size="xs"
                                      outline
                                      color="primary"
                                      className="ml-2 btn-round"
                                      style={{
                                        marginTop: '4px',
                                        marginBottom: '4px',
                                      }}
                                      title=" Take Control"
                                      onClick={() => {
                                        this.twilioConnectionToUserChat(
                                          selectedChat.botConversationId,
                                          selectedChat.visitor.location,
                                          selectedChat.visitor.ipAddress,
                                          selectedChat.conversationId,
                                          selectedChat.channel
                                        );
                                      }}
                                    >
                                      <i className="iconsminds-control-2"></i>{' '}
                                    </Button>
                                  )}
                                  {/* Language Dropdown */}
                                  <UncontrolledDropdown
                                    className="dropdown-menu-right mr-2"
                                    style={{
                                      marginTop: '4px',
                                      marginBottom: '4px',
                                    }}
                                  >
                                    <DropdownToggle
                                      size="xs"
                                      outline
                                      color="primary"
                                      className="btn-round align-items-center mr-1 ml-2"
                                      title="Language"
                                    >
                                      {this.state.translateLang === '' ? (
                                        <span>
                                          <FontAwesomeIcon
                                            icon={faLanguage}
                                            className="fa"
                                            style={{ fontSize: '15px' }}
                                          />
                                        </span>
                                      ) : (
                                        <span className="name">
                                          {this.state.translateLang?.toUpperCase()}
                                        </span>
                                      )}
                                    </DropdownToggle>

                                    <DropdownMenu
                                      right
                                      style={{ marginTop: '100px' }}
                                    >
                                      {localeOptions.map((elem, index) => (
                                        <DropdownItem
                                          onClick={() =>
                                            this.handleChangeLocale(
                                              elem.id,
                                              elem.direction
                                            )
                                          }
                                          key={index}
                                        >
                                          {elem.name}
                                        </DropdownItem>
                                      ))}
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                  {selectedChat && (
                                    <Fragment>
                                      <Button
                                        size="xs"
                                        outline
                                        color="primary"
                                        onClick={() => this.statustoggle()}
                                        className="ml-2 btn-round"
                                        style={{
                                          marginTop: '4px',
                                          marginBottom: '4px',
                                        }}
                                      >
                                        {selectedChat.status === 'Opened' ? (
                                          <Fragment>
                                            <FontAwesomeIcon
                                              icon={faArrowDown}
                                              title="Close Conversation"
                                            ></FontAwesomeIcon>{' '}
                                          </Fragment>
                                        ) : (
                                          <Fragment>
                                            <FontAwesomeIcon
                                              icon={faUpload}
                                              title="Open Conversation"
                                            ></FontAwesomeIcon>{' '}
                                          </Fragment>
                                        )}
                                      </Button>
                                    </Fragment>
                                  )}
                                </div>
                              </div>
                              {this.getVisitorOnlineDetail()}
                            </Colxx>
                          </Row>
                          <Fragment>
                            {/* {selectedChat && webRTCIntegration !== undefined ? (
                              <WebRTC
                                isOncall={this.state.isOncall}
                                rtcNumber={rtcNumber}
                                number={
                                  selectedChat.visitor?.nmsAni
                                    ? selectedChat.visitor?.nmsAni
                                    : ''
                                }
                                handleBackToChat={() =>
                                  this.setState({
                                    isOncall: !this.state.isOncall,
                                  })
                                }
                                webRTCIntegration={webRTCIntegration}
                              ></WebRTC>
                            ) : null} */}
                          </Fragment>
                        </NavItem>
                      </Nav>
                    </CardHeader>
                  )}
                  <Chat
                    chat={selectedChat}
                    isLatestConversation={
                      this.state?.isLatestConversation
                        ? this.state?.isLatestConversation
                        : false
                    }
                    accessToken={this.state.accessToken}
                    twilioConversations={this.state.twilioConversations}
                    twilioChatId={this.state.twilioChatId}
                    forceRefresh={this.state.forceRefresh}
                    closeTwilioConversation={this.closeTwilioConversation}
                    ref={this.myChatRef}
                    profileName={user && user.profile.name}
                    stopBlink={this.stopBlink}
                    chatReplyTemplates={this.state.chatReplyTemplates}
                    setBlankTwilioId={this.setBlankTwilioId}
                    twilioConnectionToUserChat={this.twilioConnectionToUserChat}
                    translateLang={this.state.translateLang}
                    isTranslate={this.state.isTranslate}
                  />{' '}
                </Fragment>
              )}
          </Colxx>
          <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-4 pl-0">
            {selectedChat && selectedChat.visitor != null && (
              <CardHeader className="pl-1 pr-1 pt-4">
                <Nav
                  tabs
                  className="card-header-tabs ml-0 mr-0"
                  style={{
                    backgroundColor: 'white',
                    border: '1px solid lightgray',
                  }}
                >
                  <NavItem className="text-center">
                    <NavLink
                      style={{
                        background: `${detailsTab === 'CallInfo' ? 'white' : 'none'
                          }`,
                        cursor: 'pointer',
                      }}
                      className={classnames({
                        active: detailsTab === 'CallInfo',
                        'nav-link': true,
                      })}
                      onClick={() => {
                        this.setState({ detailsTab: 'CallInfo' });
                      }}
                      to="#"
                      title="Call Info"
                    >
                      <i
                        className="iconsminds-profile"
                        style={{
                          fontSize: '17px',
                          color: 'var(--theme-color-1)',
                        }}
                      >
                        {/* <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1"
                          stroke="currentColor"
                          class="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                          />
                        </svg> */}
                      </i>
                      {selectedChat !== null &&
                        selectedChat.channel === 'PhoneSuite' ? (
                        <IntlMessages id="content.visitorinfo" />
                      ) : (
                        <IntlMessages id="content.callinfo" />
                      )}{' '}
                    </NavLink>
                  </NavItem>
                  <NavItem className="text-center">
                    <NavLink
                      style={{
                        background: `${detailsTab === 'KnowledgeSearch' ? 'white' : 'none'
                          }`,
                        cursor: 'pointer',
                      }}
                      className={classnames({
                        active: detailsTab === 'KnowledgeSearch',
                        'nav-link': true,
                      })}
                      onClick={() => {
                        this.setState({ detailsTab: 'KnowledgeSearch' });
                      }}
                      to="#"
                      title="Knowledge Search"
                    >
                      <i className="svg-class">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1"
                          stroke="currentColor"
                          class="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                          />
                        </svg>
                      </i>
                      {detailsTab === 'KnowledgeSearch' && (
                        <IntlMessages id="content.knowledgesearch" />
                      )}
                    </NavLink>
                  </NavItem>
                  {/* <NavItem className="text-center">
                    <NavLink
                      style={{
                        background: `${detailsTab === 'EmailAssist' ? 'white' : 'none'
                          }`,
                        cursor: 'pointer',
                      }}
                      className={classnames({
                        active: detailsTab === 'EmailAssist',
                        'nav-link': true,
                      })}
                      onClick={() => {
                        this.setState({ detailsTab: 'EmailAssist' });
                      }}
                      to="#"
                    >
                      <i className="svg-class">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1"
                          stroke="currentColor"
                          class="size-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9 3.75H6.912a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859M12 3v8.25m0 0-3-3m3 3 3-3"
                          />
                        </svg>
                      </i>
                      {detailsTab === 'EmailAssist' && ' Email Assist'}
                    </NavLink>
                  </NavItem> */}
                  {this.props.integrations !== undefined &&
                    this.props.integrations.filter(
                      (f) =>
                        f.channel === 'Amadues' &&
                        f.properties.includes(this.props.propertyId) &&
                        f.disabled === false
                    ).length > 0 && (
                      <NavItem className="text-center">
                        <NavLink
                          style={{
                            background: `${detailsTab === 'Availability & Rates'
                              ? 'white'
                              : 'none'
                              }`,
                            cursor: 'pointer',
                          }}
                          className={classnames({
                            active: detailsTab === 'Availability & Rates',
                            'nav-link': true,
                          })}
                          onClick={() => {
                            this.setState({
                              detailsTab: 'Availability & Rates',
                            });
                          }}
                          to="#"
                          title="Availability & Rates"
                        >
                          <i className="svg-class">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1"
                              stroke="currentColor"
                              class="size-6"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6.75 2.994v2.25m10.5-2.25v2.25m-14.252 13.5V7.491a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v11.251m-18 0a2.25 2.25 0 0 0 2.25 2.25h13.5a2.25 2.25 0 0 0 2.25-2.25m-18 0v-7.5a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v7.5m-6.75-6h2.25m-9 2.25h4.5m.002-2.25h.005v.006H12v-.006Zm-.001 4.5h.006v.006h-.006v-.005Zm-2.25.001h.005v.006H9.75v-.006Zm-2.25 0h.005v.005h-.006v-.005Zm6.75-2.247h.005v.005h-.005v-.005Zm0 2.247h.006v.006h-.006v-.006Zm2.25-2.248h.006V15H16.5v-.005Z"
                              />
                            </svg>
                          </i>

                          {detailsTab === 'Availability & Rates' && (
                            <IntlMessages id="content.availabilityrates" />
                          )}
                        </NavLink>
                      </NavItem>
                    )}
                </Nav>
              </CardHeader>
            )}
            <TabContent activeTab={this.state.detailsTab} className="">
              <TabPane tabId="CallInfo" className="chat-app-tab-pane">
                {this.state.twilioLoaded &&
                  (this.state.chatBotConversations.length > 0 ||
                    this.state.agentConversations.length > 0 ||
                    this.state.waitingConversations.length > 0) &&
                  this.state.agentAccess === true && (
                    <Fragment>
                      {selectedChat && selectedChat.visitor != null && (
                        <Visitor
                          hideButton={true}
                          item={selectedChat}
                          twilioConnectionToUserChat={
                            this.twilioConnectionToUserChat
                          }
                          StopFacebookChat={this.StopFacebookChat}
                          ResumeFacebookChat={this.ResumeFacebookChat}
                          toggle={this.toggle}
                          clickedLinks={
                            selectedChat.clickedLinks !== undefined
                              ? selectedChat.clickedLinks
                              : undefined
                          }
                          recordingurl={this.state.recordingurl}
                          transcript={this.state.transcript}
                          quickReplyTemplates={this.state.quickReplyTemplates}
                          propertyId={this.props.propertyId}
                          loadQuickTemmplates={this.loadQuickTemmplates}
                          statustoggle={this.statustoggle}
                          twilioChatId={this.state.twilioChatId}
                          handleMaskClick={this.handleMaskClick}
                          isMasked={this.state.isMasked}
                        />
                      )}
                    </Fragment>
                  )}
              </TabPane>
              <TabPane tabId="KnowledgeSearch" className="chat-app-tab-pane">
                <KnowledgeSearch></KnowledgeSearch>
              </TabPane>
              <TabPane
                tabId="EmailAssist"
                className="chat-app-tab-pane"
              ></TabPane>
              {this.props.integrations !== undefined &&
                this.props.integrations.filter(
                  (f) =>
                    f.channel === 'Amadues' &&
                    f.properties.includes(this.props.propertyId) &&
                    f.disabled === false
                ).length > 0 && (
                  <TabPane
                    tabId="Availability & Rates"
                    className="chat-app-tab-pane"
                  >
                    <AvailabilityAndRates
                      amadues={
                        this.props.integrations.filter(
                          (f) =>
                            f.channel === 'Amadues' &&
                            f.properties.includes(this.props.propertyId) &&
                            f.disabled === false
                        )[0]
                      }
                    ></AvailabilityAndRates>
                  </TabPane>
                )}
            </TabContent>
          </Colxx>
        </Row>
        <Row>
          {!this.state.twilioLoaded && (
            <Fragment>
              <div className="loading"></div>
              <div
                style={{
                  textAlign: 'center',
                  fontSize: '16px',
                  margin: '16px 40px',
                }}
              >
                <IntlMessages id="dashboard.hang_in_there" />
              </div>
            </Fragment>
          )}

          {this.state.agentAccess === false && (
            <Fragment>
              <div
                style={{
                  position: 'absolute',
                  left: '40%',
                  top: '30%',
                }}
              >
                {/* No active chats at the moment */}
                <img
                  src={noagentrole}
                  alt="No Active Conversations"
                  style={{ maxWidth: '400px' }}
                />
              </div>
            </Fragment>
          )}
          {this.TransferBotToMessanger()}
          {this.TransferToBot()}
          {/* {this.state.chatInvitations.length > 0 && (
            <Fragment>
              <div className="ongoing">
                <ul style={{ float: 'right' }}>
                  {this.state.chatInvitations.map((person, i) => (
                    <div className="msg_box" style={{ right: `${270 * i}px` }}>
                      <div className="msg_head">
                        <div
                          className="chatclose"
                          onClick={() => this.rejectChat(person)}
                        >
                          x
                        </div>
                      </div>
                      <div className="msg_wrap">
                        <div className="msg_body">
                          <p>
                            User requested to chat with the agent. Please click
                            accept to connect to conversation or click cancel to
                            close the request{' '}
                          </p>
                          <p>
                            <Button
                              color="primary"
                              outline
                              size="xs"
                              onClick={() => this.acceptChat(person)}
                              style={{ borderRadius: '6px' }}
                            >
                              Accept
                            </Button>{' '}
                            <Button
                              color="secondary"
                              outline
                              size="xs"
                              onClick={() => this.rejectChat(person)}
                              style={{ borderRadius: '6px' }}
                            >
                              Cancel
                            </Button>{' '}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </ul>
              </div>
            </Fragment>
          )} */}
          <Row>
            <Colxx xxs="12">
              <Modal isOpen={this.state.statusmodal} toggle={this.statustoggle}>
                <ModalHeader toggle={this.statustoggle}>
                  Change Conversation Status
                </ModalHeader>
                <ModalBody>
                  <Row>
                    <Colxx xxs="12">
                      <Row className="mb-2">
                        <Colxx xxs="3">
                          <label>
                            <IntlMessages id="Status" />
                          </label>
                        </Colxx>
                        <Colxx xxs="9">
                          <Input className='input_sty'
                            type="select"
                            value={this.state.cstatus}
                            name="cstatus"
                            onChange={this.handleInputChange}
                          >
                            <option value="Opened">New</option>
                            <option value="Closed">Closed</option>
                          </Input>
                        </Colxx>
                      </Row>
                      <Row>
                        <Colxx xxs="3">
                          <Button
                            color="primary"
                            className="mb-2"
                            onClick={this.handleStatusSubmit}
                          >
                            Save
                          </Button>
                        </Colxx>
                      </Row>
                    </Colxx>
                  </Row>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
          <Validation
            open={this.state.open}
            messages={this.state.msg}
            toggle={() => {
              this.setState({ open: false });
            }}
          ></Validation>
        </Row>
      </Fragment>
    );
  }
}
const mapStateToProps = ({
  chatListApp,
  usersListApp,
  settings,
  signalRConnection,
  oidc,
}) => {
  const { propertyId, timeZone, locale, email } = settings;
  const { properties } = usersListApp;
  return {
    chatListApp,
    usersListApp,
    propertyId,
    timeZone,
    locale,
    email,
    signalRConnection,
    properties,
    user: oidc.user,
  };
};

export default injectIntl(
  connect(mapStateToProps, {
    getChatList,
    getChatListSearch,
    getChat,
    getPropertyList,
    createTicket,
    BotBlink,
    AgentBlink,
    pushTwilioConversations,
  })(ActiveConversation)
);
